export default {
  hi: 'Hi',
  youArePartOfKeybe: '😃 ¡Wow! Now you are part of the Keybe family',
  areYouReady: 'Are you ready?',
  teachKeybe: 'i will teach you how to use Keybe',
  completeThese: 'Complete these',
  basicTasks: 'basic tasks',
  sendYourFirstWhatsapp: 'Send your first WhatsApp',
  connectYourChannels: 'Connect your channels',
  inviteYourTeam: 'Invite your team',
  uploadYourFirstDatabase: 'Upload your first database',
  sendWhatsappCampaign: 'Send a WhatsApp campaign',
  continue: 'Continue',
  doItAgain: 'Do it again',
  inviteTeamTitle1: 'You have the ',
  inviteTeamTitle2: ' plan, you can add up to ',
  inviteTeamTitle3: ' people to your account',
  inviteTeamSubtitle: 'Add the email of the people in your team and the role that you want them to have',
  inviteMailPlaceholder: 'Type the email of the person you want to invite',
  admin: 'Admin',
  coordinator: 'Coordinator',
  adviser: 'Adviser',
  sendInvitations: 'Send invitations',
  invitationsSent: 'Invitations sent successfully!',
  unavailable: 'Unavailable',
  downloadApp: 'Download App',
  appTour: 'App Tour'
}
